import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';

import * as config from './config'
import { YMInitializer } from './components/utils/yandex-metrika';
import LoadingPage from './pages/LoadingPage'
import NotFoundPage from './pages/NotFoundPage'
import PaymentFailurePage from './pages/PaymentFailurePage'
import NotImplementedPage from './pages/NotImplementedPage'
import EventPage from './pages/EventPage'
import BookingPage from './pages/BookingPage'
import OrderPage from './pages/OrderPage'
import RulesPage from './pages/RulesPage'
import SupportPage from './pages/SupportPage'
import PublicOfferPage from './pages/PublicOfferPage'
import IndexPage from './pages/IndexPage'
import SeatsEditingPage from './pages/SeatsEditingPage'
import { Styles } from './layout/StylesBlock'


class App extends Component {
  render() {
    return (
      <>
        <Styles />

        <YMInitializer accounts={[config.YANDEX_METRIKA_ACCOUNT_ID]} options={{
              clickmap:true,
              trackLinks:true,
              accurateTrackBounce:true,
              webvisor:true,
              ecommerce:"dataLayer"
        }}/>

        <Router>
          <Switch>
            <Route exact path='/' component={IndexPage} />
            <Route exact path='/loading' component={LoadingPage} />
            <Route exact path='/not-found' component={NotFoundPage} />
            <Route exact path='/not-implemented' component={NotImplementedPage} />
            <Route exact path='/payment-failure' component={PaymentFailurePage} />
            <Route exact path='/rules' component={RulesPage} />
            <Route exact path='/support' component={SupportPage} />
            <Route exact path='/public_offer' component={PublicOfferPage} />
            <Route exact path='/order/:orderId' component={OrderPage} />
            <Route exact path='/event/:eventId' component={EventPage} />
            <Route exact 
              path='/event/:eventId/performance/:performanceId' 
              component={BookingPage} />
            <Route exact 
              path='/event/:eventId/performance/:performanceId/edit-seats'
              component={SeatsEditingPage} />
            <Route exact 
              path='/embedded/event/:eventId/performance/:performanceId' 
              render={(routeProps) => <BookingPage {...routeProps} isEmbedded={true} />} />
            <Redirect to="/not-found" />
          </Switch>
        </Router>
      </>
    );
  }
}

export default App;
